module.exports = __webpack_public_path__ + "img/trial4-1.2bf5855c.png";